import {
  createGlobalStyle,
  DefaultTheme,
  GlobalStyleComponent,
} from "styled-components";
import { theme } from "./theme";

export const GlobalStyle: GlobalStyleComponent<
  object,
  DefaultTheme
> = createGlobalStyle`
  *,
  ::after,
  ::before {
    box-sizing: border-box;
    outline: none;
  }

  html {
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -ms-overflow-style: scrollbar;
    -webkit-tap-highlight-color: transparent;
    scroll-behavior: smooth;
  }
   
  @keyframes pulse {
    0% {transform: scale(1);}
    50% {transform: scale(1.25);}
    100% {transform: scale(1);}
  }
  
  article,
  aside,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  nav,
  section {
    display: block;
  }

  button{
    border: none;
    font-family: ${theme.font.montserrat};
  }

  body {
    padding: 0;
    margin: 0;
    font-size: 16px;
    line-height: 1.35;
    background: ${theme.colors.mainBg};
    color: ${theme.colors.black};
  }
  
  body, input, textarea {
    font-family: ${theme.font.roboto};
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: ${theme.font.poppins};
    margin-top: 0;
    margin-bottom: 0;
    font-weight: bold;
  }

  .required {
    color: ${theme.colors.erro};
    margin-left: 3px;
  }

  .p-dropdown-items-wrapper {

    ::-webkit-scrollbar {
    width: 8px;
    }

    ::-webkit-scrollbar-track {
    background-color: ${theme.colors.darkBlue};
    }

    ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray800};
    }
  }

  .p-dropdown-header {
    background-color: ${theme.colors.blue900} !important;
  }

  .p-dropdown-header .p-dropdown-filter-container input {
    background-color: ${theme.colors.blue900};
    color: ${theme.colors.white} !important;
    border-radius: 1rem;
  }

  .p-dropdown-items {
    background-color: ${theme.colors.blue900} !important;
    color: ${theme.colors.white} !important;

    li {
      color: ${theme.colors.white} !important;

      &:hover {
        background-color: ${theme.colors.blue400} !important;
      }
    }

    li.p-highlight {
      background-color: ${theme.colors.blue400} !important;
    }
  }

  span[class="p-dropdown-label p-inputtext p-placeholder"] {
    color: ${theme.colors.white} !important;
  }

  span[class="p-dropdown-label p-inputtext"] {
    color: ${theme.colors.white} !important;
  }
 
  .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider{
    background: ${theme.colors.green}!important;
  }

.confirm-custom-dialog {
  .p-button.p-confirm-dialog-accept {
    color: #fff;
    background-color: #0C7488;
  }
  .p-button {
      color: #0C7488;
      background-color: #DBFBFF;
      border-radius: 30px;
      font-weight: 100;
      font-family: 'Poppins';
      padding: 7px 30px;
      outline: none;
      border: none;
      span{
        font-weight: 300;
      }
  }
  .p-dialog-footer {
    display: flex;
    justify-content: center;
  }
}

.confirm-custom-dialog {
    min-width: 400px;
}

.p-dialog-content {
  &::-webkit-scrollbar {
      width: 8px !important;
    }

    &::-webkit-scrollbar-track {
      background-color: ${theme.colors.blue800} !important;
    }

    &::-webkit-scrollbar-thumb {
      background: ${theme.colors.gray800} !important;
      border-radius: 0 !important;
    }
}

@media screen and (max-width: 479px) {
  .confirm-custom-dialog {
    min-width: 300px;
  }
  
} 

.openSelect *{
  overflow: hidden!important;
}

.fade.alert.alert-danger.show {
    position: absolute;
    bottom: 0;
    transform: translateX(-50%);
    left: 50%;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  cursor: pointer;
  filter: invert(1) brightness(100%);
}

.p-inputswitch-slider {
  background: ${theme.colors.erro} !important;
}

input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 30px ${theme.colors.blue900} inset;
    -webkit-text-fill-color: white !important;
}
`;
